import { defineStore } from "pinia";

export const useErrorStore = defineStore("ErrorStore", () => {
  const isOpen = ref(false);
  const dialogMessage = ref<string>("");
  const buttonTitle = ref<string>("");
  let complete = () => {};

  const show = (message: string, button: string, completed: () => void) => {
    dialogMessage.value = message;
    buttonTitle.value = button;
    isOpen.value = true;
    complete = completed;
  };

  const showConnectionError = (message: string) => {
    if (isSentrySampled(useRuntimeConfig().public.appEnv === "production")) {
      sentryWarnLog(`ErrorStore.showConnectionError: ${message}`);
    }
    show("接続に失敗しました\n通信環境を確認の上、再試行してください", "再試行", () => {
      location.reload();
    });
  };

  const showInvalidContents = (message: string) => {
    if (isSentrySampled(useRuntimeConfig().public.appEnv === "production")) {
      sentryWarnLog(`ErrorStore.showConnectionError: ${message}`);
    }
    show("無効なURLです", "トップへ", () => {
      // リロードしながらホームに戻る
      reloadNuxtApp({
        path: "/",
        ttl: 1000, // デフォルト 10000
      });
    });
  };

  const close = () => {
    complete();
    isOpen.value = false;
  };

  const reset = () => {
    isOpen.value = false;
  };

  return {
    isOpen,
    dialogMessage,
    buttonTitle,
    show,
    showConnectionError,
    showInvalidContents,
    close,
    reset,
  };
});
